import { AssignTransportToStation, AvailableTransport, AvailableTransports, AvailableTransportsSelection, DisableStationFetch } from './../../../../widgets/control/sac-client/model/sac-client.model';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SacClientService } from './../../../../widgets/control/sac-client/service/sac-client.service';
import { TransportAssignmentSight } from '../action-tablet-planned-assignments.model';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'yard-action-tablet-planned-assignments-action-dialog',
    templateUrl: './action-tablet-planned-assignments-action-dialog.component.html',
    styleUrls: ['./action-tablet-planned-assignments-action-dialog.component.scss'],
    standalone: false
})
export class ActionTabletPlannedAssignmentsActionDialogComponent implements OnInit {

  formGroup = new FormGroup({
    minutesCount: new FormControl(null, [Validators.required]),
    action: new FormControl(null, [Validators.required])
  });

  currentSelectedOption: string;
  transports: AvailableTransport[];

  selectedTransportToFetch: AvailableTransport;

  constructor(
    public dialogRef: MatDialogRef<ActionTabletPlannedAssignmentsActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public transportAssignmentSight: TransportAssignmentSight,
    private sacClientService: SacClientService
  ) { }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(value => {
      this.currentSelectedOption = value.action;
      if (this.currentSelectedOption === 'fetch-another-transport') {
        this.updateTransports();
      }
    });
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public confirm() {
    if (this.currentSelectedOption === 'fetch-now') {
        this.assignTransportToStation();
      } else if (this.currentSelectedOption === 'disable-fetch') {
        this.disableFetchForStation();
      } else if (this.currentSelectedOption === 'fetch-another-transport') {
        this.assignAnotherTransportToStation();
      }
    this.dialogRef.close(true);
  }

  selectTransportToFetch(transport: AvailableTransport) {
    this.selectedTransportToFetch = transport;
  }

  private updateTransports() {
    const selection = new AvailableTransportsSelection();
    selection.station = { id: this.transportAssignmentSight.stationId };
    this.sacClientService.loadAvailableTransports(selection).subscribe(
      availableTransports => {

        this.transports = availableTransports.transports.filter(t => t.id !== this.transportAssignmentSight.transport.id);

        // const transportGroup = this.transportGroups.find(tg => tg.key === 'transports');
        // const backupTransports = this.transportGroups.find(tg => tg.key === 'backupTransports');

        // this.mergeTransportsToGroup(availableTransports.transports, transportGroup);
        // this.mergeTransportsToGroup(availableTransports.backupTransports, backupTransports);

        // this.setDefaultSelectionOfGroup(transportGroup, backupTransports);

      }
    );
  }

  private assignTransportToStation() {
    const assignment = new AssignTransportToStation();
        assignment.transportStationAssignment = {
          station: { id: this.transportAssignmentSight.stationId }, transport: { id: this.transportAssignmentSight.transport.id }
        };
    this.sacClientService.assignTransport(assignment).pipe(delay(1000)).subscribe((result) => {
      console.log('assignTransportToStation executed', result);
    });
  }

  private assignAnotherTransportToStation() {
    const assignment = new AssignTransportToStation();
    assignment.transportStationAssignment = {
          station: { id: this.transportAssignmentSight.stationId }, 
          transport: { id: this.selectedTransportToFetch.id }
    };
    assignment.asBackup = this.selectedTransportToFetch.asBackup;
    this.sacClientService.assignTransport(assignment).pipe(delay(1000)).subscribe((result) => {
      console.log('assignTransportToStation executed', result);
    });
  }

  private disableFetchForStation() {
    const disableFetch = new DisableStationFetch({
      stationId: this.transportAssignmentSight.stationId,
      disableForMinutes: this.formGroup.controls.minutesCount.value ?? 5,
    });
    
    this.sacClientService.disableFetchUntilForStation(disableFetch).subscribe((result) => {
      console.log('disableFetch executed:', result);
    });
  }

}
